import { useEffect, useState } from 'react'
import { DEBOUNCE_TIME_500_MS } from './queries/constants'

export default function useDebounce<T>(value: T, delay: number = DEBOUNCE_TIME_500_MS) {
  const [debouncedValue, setDebouncedValue] = useState<T | undefined>()

  useEffect(() => {
    const handler: NodeJS.Timeout = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    // Cancel the timeout if value changes (also on delay change or unmount)
    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
